import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Spinner,
  Badge,
} from 'reactstrap';
import { api } from '../../config';
import CountUp from 'react-countup';
import FeatherIcon from 'feather-icons-react';

const WidgetStatus = ({ token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const res = await fetch(`${api.API_URL}/dashboard/procurement`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error('Failed to fetch data');
        }

        const result = await res.json();
        setData(result);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    if (token) {
      fetchData();
    }
  }, [token]);

  const summaryItems = [
    {
      key: 'TotalProcurements',
      label: 'Total Procurements',
      icon: 'layers',
      color: 'primary',
    },
    {
      key: 'TotalCompletedProcurements',
      label: 'Completed',
      icon: 'check-circle',
      color: 'success',
    },
    {
      key: 'TotalDraftProcurements',
      label: 'Draft',
      icon: 'file-text',
      color: 'warning',
    },
    {
      key: 'TotalHpsStatusRequested',
      label: 'HPS Requested',
      icon: 'clock',
      color: 'info',
    },
    {
      key: 'TotalHpsStatusSubmitted',
      label: 'HPS Submitted',
      icon: 'send',
      color: 'secondary',
    },
    {
      key: 'TotalTenderEvaluationAwaitingEvaluation',
      label: 'Awaiting Evaluation',
      icon: 'watch',
      color: 'warning',
    },
    {
      key: 'TotalTenderEvaluationReadyForEvaluation',
      label: 'Ready for Evaluation',
      icon: 'play-circle',
      color: 'primary',
    },
    {
      key: 'TotalTenderEvaluationUnderEvaluation',
      label: 'Under Evaluation',
      icon: 'activity',
      color: 'info',
    },
  ];

  if (loading) {
    return (
      <Card className='border-0 shadow-sm'>
        <CardBody
          className='d-flex justify-content-center align-items-center'
          style={{ minHeight: '220px' }}
        >
          <Spinner color='primary' />
        </CardBody>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className='border-0 shadow-sm rounded-3'>
        <CardBody
          className='d-flex justify-content-center align-items-center'
          style={{ minHeight: '220px' }}
        >
          <p className='text-danger mb-0'>Error: {error}</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className='border-0 shadow-sm rounded-3'>
      <CardHeader className='bg-transparent border-0 px-4 pt-4 d-flex align-items-center gap-2'>
        <FeatherIcon icon='bar-chart-2' size={16} className='text-primary' />
        <div>
          <h5 className='mb-1 fw-semibold'>Procurement Overview</h5>
          <p className='text-muted mb-0 fs-13'>
            Status procurement terkini dalam satu ringkasan.
          </p>
        </div>
        <Badge color='primary' pill className='ms-auto fw-normal'>
          {summaryItems.length} Metrics
        </Badge>
      </CardHeader>
      <CardBody className='p-4'>
        <Row className='g-3'>
          {summaryItems.map(item => (
            <Col key={item.key} xl={3} md={6}>
              <div className='d-flex align-items-center p-3 rounded-3 border bg-white h-100 dashboard-metric-card'>
                <div className='dashboard-stat-icon me-3'>
                  <span
                    className={`d-inline-flex align-items-center justify-content-center bg-${item.color}-subtle rounded-3 text-${item.color} fs-5`}
                  >
                    <FeatherIcon icon={item.icon} size={18} />
                  </span>
                </div>
                <div className='flex-grow-1 min-width-0'>
                  <p className='text-muted mb-1 fs-12 text-truncate text-uppercase fw-medium'>
                    {item.label}
                  </p>
                  <h4 className='fw-bold mb-0 text-dark'>
                    <CountUp start={0} end={data[item.key] || 0} duration={2} />
                  </h4>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default WidgetStatus;
